import { OmniaObjectType } from "./omnia"
import { INutritionPlan } from "./types"

export function getRequirementsActivity() {
    return {
        action: "calc",
        resourceType: OmniaObjectType.NutritionRequirement,
        conflictId: "nutrition"
    }
}

export function getPlanActivity(create: boolean, plan: INutritionPlan) {

    return {
        action: create ? "c" : "u",
        resourceId: plan?.NutritionPlanId,
        resourceType: OmniaObjectType.NutritionPlan,
        conflictId: "nutrition",
        year: plan.YearId,
        data: {
            Name: plan?.Name
        }
    }

}
